import DownloadLink from "react-download-link";
import SimpleMdeReact from "react-simplemde-editor";
import { dynamicImage } from "../../../../../utils";
import { MdeEditorText } from "../../../../../data/applications/LetterBox";
import SvgIcon from "../../../../../coreComponents/SvgIcon";
import { Image } from "../../../../../coreComponents/Image";

const UserFooter = () => {

  return (

    <div className="user-footer">
      <div>
        <SvgIcon iconId="attchment" />
        <span className="f-light">{"Attachments"}</span>
      </div>
      <div className="d-inline-block">
        <div className="attchment-file common-flex">
          <div className="common-flex align-items-center">
            <Image src={dynamicImage(`email-template/pdfs.png`)} alt="pdf" />
            <div className="d-block">
              <p className="mb-0">Offer_Letter.pdf</p>
              <p className="mb-0">200KB</p>
            </div>
          </div>
          <DownloadLink filename="myfile.txt" label={<i className="fa fa-download f-light"></i>} />
        </div>
      </div>
      <div className="toolbar-box">
        <div id="editor">
          <SimpleMdeReact id="editor_container" placeholder={MdeEditorText} options={{ autofocus: true, spellChecker: false }} />
        </div>
      </div>
    </div>
  );
};

export default UserFooter;